import { __exports as logger } from './_virtual-logger.js';

var hasRequiredLogger;

function requireLogger () {
	if (hasRequiredLogger) return logger;
	hasRequiredLogger = 1;

	Object.defineProperty(logger, "__esModule", {
	  value: true
	});
	logger.logger = void 0;
	const error = (errorMessage, contextData) => {
	  console.error(errorMessage, JSON.stringify(contextData));
	};
	const warn = (errorMessage, contextData) => {
	  console.warn(errorMessage, JSON.stringify(contextData));
	};
	const info = errorMessage => {
	  console.log(errorMessage);
	};
	logger.logger = {
	  error,
	  warn,
	  info
	};
	
	return logger;
}

export { requireLogger as __require };
//# sourceMappingURL=vp-js-token-engine-build-infrastructure-logger.js.map
